import Button from './Button.js';
import SettlementModalShell from './SettlementModalShell.js';

export default function PaymentProofModal({ url, title, onClose }) {
  if (!url) return null;
  return (
    <SettlementModalShell
      title={title || 'Payment proof'}
      size="sm"
      onClose={onClose}
      footer={(
        <div className="flex justify-end">
          <Button variant="secondary" onClick={onClose}>Close</Button>
        </div>
      )}
    >
      <img
        src={url}
        alt="Payment proof"
        className="w-full max-h-[60vh] object-contain rounded-lg bg-gray-50"
      />
    </SettlementModalShell>
  );
}
